import { ReactNode } from 'react';

export interface HistoryProps {
  sweepHistory: ReactNode;
  topVoters: ReactNode;
}

const History = ({ sweepHistory, topVoters }: HistoryProps) => {
  return (
    <div className="space-y-4">
      <header className="p-4 md:pt-10 md:px-10">
        <h1 className="text-4xl font-medium">{'Sweep History'}</h1>
      </header>
      <div className="rounded-xl bg-gray-800">{sweepHistory}</div>
      <div className="bg-gray-800 rounded-xl">
        <header className="border-b border-gray-400 px-10 flex space-x-4">
          <button
            type="button"
            className="p-5 text-white border-b border-brand-blue -mb-px text-xs"
          >
            {'Top Voters'}
          </button>
        </header>
        <section className="p-6 px-10">{topVoters}</section>
      </div>
    </div>
  );
};

export default History;
